import { Injectable } from '@angular/core';
import { IntegrationsService } from 'app/integrations/integration.service';
import { IntegrationPlatformType } from 'app/integrations/models/integration.model';
import {
  ClientifySpecifics,
  HubspotSpecifics,
  IntegromatSpecifics,
  LiveChatSpecifics,
  MagentoSpecifics,
  PipeDriveSpecifics,
  PlatformSpecifics,
  ShoperSpecifics,
  ShopifySpecifics,
  TwoWaySpecifics,
  ZapierSpecifics,
  ZendeskSpecifics,
} from 'app/integrations/integration-platform-specifics';

@Injectable({
  providedIn: 'root',
})
export class IntegrationPlatformSpecificsFactory {
  private specifics: Map<IntegrationPlatformType, PlatformSpecifics>;

  constructor(private integrationsService: IntegrationsService) {
    this.specifics = new Map([
      [IntegrationPlatformType.SHOPIFY, new ShopifySpecifics()],
      [IntegrationPlatformType.LIVECHAT, new LiveChatSpecifics()],
      [IntegrationPlatformType.PIPEDRIVE, new PipeDriveSpecifics(integrationsService)],
      [IntegrationPlatformType.MAGENTO, new MagentoSpecifics()],
      [IntegrationPlatformType.SHOPER, new ShoperSpecifics()],
      [IntegrationPlatformType.ZENDESK, new ZendeskSpecifics(integrationsService)],
      [IntegrationPlatformType.HUBSPOT, new HubspotSpecifics()],
      [IntegrationPlatformType.ZAPIER, new ZapierSpecifics()],
      [IntegrationPlatformType.TWO_WAY, new TwoWaySpecifics()],
      [IntegrationPlatformType.INTEGROMAT, new IntegromatSpecifics()],
      [IntegrationPlatformType.CLIENTIFY, new ClientifySpecifics()],
    ]);
  }

  public getSpecifics(type: IntegrationPlatformType): PlatformSpecifics {
    return this.specifics.get(type);
  }
}
